"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossOriginConfig = exports.OrderConfig = exports.SyncConfig = void 0;
var SyncConfig;
(function (SyncConfig) {
    SyncConfig["DEFER"] = "DEFER";
    SyncConfig["ASYNC"] = "ASYNC";
    SyncConfig["DEFAULT"] = "DEFAULT";
})(SyncConfig || (exports.SyncConfig = SyncConfig = {}));
var OrderConfig;
(function (OrderConfig) {
    OrderConfig["TOP"] = "TOP";
    OrderConfig["BOTTOM"] = "BOTTOM";
})(OrderConfig || (exports.OrderConfig = OrderConfig = {}));
var CrossOriginConfig;
(function (CrossOriginConfig) {
    CrossOriginConfig["ANONYMOUS"] = "anonymous";
    CrossOriginConfig["USE_CREDENTIALS"] = "use-credentials";
})(CrossOriginConfig || (exports.CrossOriginConfig = CrossOriginConfig = {}));
//# sourceMappingURL=constants.js.map